import { X, FileText } from "lucide-react";

const MedicineResults = ({ medicines, onRemove }) => {
  if (medicines.length === 0) {
    return null;
  }

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <div className="flex items-center space-x-2 mb-6">
        <FileText className="text-blue-600" size={20} />
        <p className="text-lg font-semibold text-gray-800">
          Prescribed Medicines
        </p>
      </div>

      {/* Desktop Table View */}
      <div className="hidden md:block overflow-x-auto">
        <table className="w-full border-collapse bg-white rounded-lg shadow-sm">
          <thead>
            <tr className="bg-gray-50">
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Medicine
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Strength
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Type
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Dosage
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Timing
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Duration
              </th>
              <th className="text-left py-3 px-4 font-semibold text-gray-700 border-b">
                Indication
              </th>
              <th className="text-center py-3 px-4 font-semibold text-gray-700 border-b">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {medicines.map((med, idx) => (
              <tr key={idx} className="hover:bg-gray-50">
                <td className="py-3 px-4 border-b">{med.name}</td>
                <td className="py-3 px-4 border-b">{med.strength}</td>
                <td className="py-3 px-4 border-b">{med.type}</td>
                <td className="py-3 px-4 border-b">{med.dosage}</td>
                <td className="py-3 px-4 border-b">{med.timing}</td>
                <td className="py-3 px-4 border-b">{med.continueTill}</td>
                <td className="py-3 px-4 border-b">{med.indication}</td>
                <td className="py-3 px-4 border-b text-center">
                  <button
                    onClick={() => onRemove(idx)}
                    className="text-red-600 hover:text-red-800 font-medium"
                  >
                    <X size={18} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Mobile Card View */}
      <div className="md:hidden space-y-3">
        {medicines.map((med, i) => (
          <div key={`${med.name} (${med.strength})`} className="card">
            <div className="flex justify-between items-start mb-3">
              <h3 className="font-semibold text-gray-800 text-sm leading-tight">
                {med.name} ({med.strength}) - {med.type}
              </h3>
              <button
                onClick={() => onRemove(i)}
                className="text-red-600 hover:text-red-800 font-medium ml-3 flex-shrink-0"
              >
                <X size={24} />
              </button>
            </div>

            <div className="space-y-2 text-sm">
              <div className="flex">
                <span className="font-medium text-gray-600 w-20 flex-shrink-0">
                  <b>Dosage:</b>
                </span>
                <span className="text-gray-800">{med.dosage}</span>
              </div>

              <div className="flex">
                <span className="font-medium text-gray-600 w-20 flex-shrink-0">
                  <b>Timing:</b>
                </span>
                <span className="text-gray-800">{med.timing}</span>
              </div>

              <div className="flex">
                <span className="font-medium text-gray-600 w-20 flex-shrink-0">
                  <b>Duration:</b>
                </span>
                <span className="text-gray-800">
                  {med.continueTill}
                </span>
              </div>

              <div className="flex">
                <span className="font-medium text-gray-600 w-20 flex-shrink-0">
                  <b>Indication:</b>
                </span>
                <span className="text-gray-800">{med.indication}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default MedicineResults;
